import { CdkDropList } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, Observable, shareReplay, tap } from 'rxjs';

@Injectable()
export class DragDropListService {
  private connectedDropLists$ = new BehaviorSubject<CdkDropList[]>([]);

  addConnectedDropList(dropList: CdkDropList): void {
    const lists = this.connectedDropLists$.getValue();
    lists.push(dropList);
    this.connectedDropLists$.next(lists);
  }

  getLists$(): Observable<CdkDropList[]> {
    return this.connectedDropLists$.pipe(
      debounceTime(50),
      tap((connectedDropLists) => {
        connectedDropLists.sort(
          (a, b) => this.getDepth(b.element.nativeElement) - this.getDepth(a.element.nativeElement),
        );
      }),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  private getDepth(element: HTMLElement): number {
    let depth = 0;
    while (element.parentElement !== null) {
      element = element.parentElement;
      depth++;
    }

    return depth;
  }
}
